import React from 'react';
import useI18n from "i18n/useI18n";
import styled from 'styled-components';
import { P } from "@etiquette-ui/typography";
import { RemoveIcon } from "@etiquette-ui/icons";
import { SwitchButton } from "@etiquette-ui/selectors";
import { INPUTS, TEXT, TEXT_PLACEHOLDER, WRONG_LIGHT } from '@etiquette-ui/colors';

const Container = styled.div`
  flex: 0 0 100%;
  display: flex;
  gap: 30px;  
  
  @media (min-width: 768px) {
    gap: 20px;
    flex: 0 0 25%;
    padding-left: 20px;
    margin-left: 0px;
    margin-left: 0px;
    flex-wrap: wrap;
    justify-content: start;   
  }
`;

const SwitchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 100%;
  gap: 8px;
  margin-left: -12px;

  .label {
    font-weight: 500;
  }

  &.__disabled {
    .label {
      color: ${TEXT};
      opacity: .5;
    }
    .switch {
      background-color: ${INPUTS};
      div {
        border-color: ${TEXT_PLACEHOLDER};
        background-color: ${INPUTS};
      }
    }
  }
`;

const DeleteContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;

  .label {
    color: ${WRONG_LIGHT};
    font-weight: 500;
  }
`;

const Switches = ({ active, onDisable, onDelete, includeDeleteOption = true }) => {
  const { translate } = useI18n();
  return (
    <Container>
      <SwitchContainer 
        onClick={onDisable}
        className={!active ? '__disabled' : ''}
      >
        <SwitchButton
          active={active}
          className='switch'
        />
        <P className='label'>{translate("Active")}</P>
      </SwitchContainer>
      {includeDeleteOption && (
        <DeleteContainer onClick={onDelete}>
          <div style={{ width: "25px", marginRight: "5px", lineHeight: "1px" }}>
            <RemoveIcon />
          </div>
          <P className='label'>{translate("remove")}</P>
        </DeleteContainer>
      )}
      
    </Container>
  )
}
export default Switches